var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 210,
    viewBox: "0 0 287 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8665_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88671 146.871L3.88672 56.0864C3.88672 35.058 3.88672 24.5439 10.4194 18.0112C16.9521 11.4785 27.4663 11.4785 48.4946 11.4785L138.793 11.4785C139.864 11.4785 140.4 11.4785 140.852 11.4969C152.459 11.9685 161.761 21.27 162.232 32.8769C162.251 33.3295 162.251 33.8649 162.251 34.9357C162.251 36.7204 162.251 37.6128 162.281 38.3671C163.067 57.7119 178.57 73.2144 197.915 74.0005C198.669 74.0311 199.561 74.0311 201.346 74.0311L204.523 74.0311C207.365 74.0311 208.785 74.0311 209.981 74.1604C220.401 75.2874 228.63 83.517 229.757 93.9367C229.887 95.1324 229.887 96.5531 229.887 99.3946L229.887 146.871C229.887 167.899 229.887 178.413 223.354 184.946C216.821 191.479 206.307 191.479 185.279 191.479L48.4946 191.479C27.4662 191.479 16.9521 191.479 10.4194 184.946C3.88671 178.413 3.88671 167.899 3.88671 146.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88671 146.871L3.88672 56.0864C3.88672 35.058 3.88672 24.5439 10.4194 18.0112C16.9521 11.4785 27.4663 11.4785 48.4946 11.4785L138.793 11.4785C139.864 11.4785 140.4 11.4785 140.852 11.4969C152.459 11.9685 161.761 21.27 162.232 32.8769C162.251 33.3295 162.251 33.8649 162.251 34.9357C162.251 36.7204 162.251 37.6128 162.281 38.3671C163.067 57.7119 178.57 73.2144 197.915 74.0005C198.669 74.0311 199.561 74.0311 201.346 74.0311L204.523 74.0311C207.365 74.0311 208.785 74.0311 209.981 74.1604C220.401 75.2874 228.63 83.517 229.757 93.9367C229.887 95.1324 229.887 96.5531 229.887 99.3946L229.887 146.871C229.887 167.899 229.887 178.413 223.354 184.946C216.821 191.479 206.307 191.479 185.279 191.479L48.4946 191.479C27.4662 191.479 16.9521 191.479 10.4194 184.946C3.88671 178.413 3.88671 167.899 3.88671 146.871Z",
    stroke: "url(#paint0_linear_8665_321)",
    strokeWidth: 1.61084
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8665_321",
    x: -52.6788,
    y: -41.3697,
    width: 339.131,
    height: 293.131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.71733
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.8799
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17464 0 0 0 0 0.335271 0 0 0 0 0.778754 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8665_321"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8665_321",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8665_321",
    x1: -81.7555,
    y1: 267.592,
    x2: 103.07,
    y2: -50.2518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DF8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353256,
    stopColor: "#00D69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0986FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector 5.1cdff6ab93a9fcde78db03a51e8b2466.svg";
export { ForwardRef as ReactComponent };